import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import 'rxjs/add/operator/toPromise';
import {webapi} from '../../shared/my-constants';

@Injectable()
export class TemrDoctorsAdviceService {
  temrDoctorsAdvice: any;
  private headers = new Headers({'Content-Type': 'application/json'});
  private ListRecord = webapi + 'temr_doctors_advice/list/?';
  private AddRecord = webapi + 'temr_doctors_advice/create';
  private EditRecord = webapi + 'temr_doctors_advice/update';
  private GetRecord = webapi + 'temr_doctors_advice/byid/';
  private DeleteRecord = webapi + 'temr_doctors_advice/delete/';
  private GetClinicalRecordByVisitId = webapi + 'temr_doctors_advice/listByVisitId/?';
  private GetClinicalRecordByTimelineId = webapi + 'temr_doctors_advice/listByTimelineId/?';
  private GetClinicalRecordByTimelineId_new = webapi + 'temr_doctors_advice/listByTimelineId_new/?';
  private GetAllRecordByTimelineList = webapi + 'temr_doctors_advice/getAllRecordByTimelineList';
  private GetRecordbypatientID = webapi + 'temr_doctors_advice/bypatientid/';

  constructor(
    private http: Http
  ) {
  }

  getAllRecordService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
    return this.http.get(this.ListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + '' + '&sort=' + sort + '&col=' + col)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getClinicalRecordByVisitIdService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
    return this.http.get(this.GetClinicalRecordByVisitId + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col)
      .toPromise()
      .then(response => response.json().content)
      .catch(this.handleError);
  }

  getClinicalRecordByTimelineId(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
    return this.http.get(this.GetClinicalRecordByTimelineId + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col)
      .toPromise()
      .then(response => response.json().content)
      .catch(this.handleError);
  }

    getClinicalRecordByTimelineId_new(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
        return this.http.get(this.GetClinicalRecordByTimelineId_new + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

  addRecordService(model: any) {
    // console.log(JSON.stringify(model));
    return this.http.post(this.AddRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  editRecordService(model: any) {
    return this.http.put(this.EditRecord, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  deleteRecordService(id: any) {
    return this.http.put(this.DeleteRecord + id, {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getRecordService(id: any) {
    return this.http.get(this.GetRecord + id)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getRecordServicebyVisitId(visitId: any) {
    // console.log(this.GetRecord + visitId);
    return this.http.get(this.GetRecord + visitId)
      .toPromise()
      .then(response => response)
      .catch(this.handleError);
  }

  getAllRecordByTimelineList(model: any) {
    return this.http.post(this.GetAllRecordByTimelineList, JSON.stringify(model), {headers: this.headers})
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  // Abhijeet Doctor Order
  getRecordbypatientIDService(id: any) {
    return this.http.get(this.GetRecordbypatientID + id)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  private handleError(error: Response | any) {
    return Promise.reject(error.message || error);
  }
}




// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/configuration/temr-doctors-advice/temr-doctors-advice.service.ts